.monaco-editor .lines-content .cdr{height:100%;position:absolute}